import i18n from '@/i18n';

const checkRole = (name, user) => {
  switch (name) {
    case "Ranking":
      return user.role === "PREMIUM";
    case "MarketCycle":
      return user.role === "STANDARD";
    case "xx":
      return ["FREE"].includes(user.role);
    case "evaluationGeneral":
    case "evaluationMethods":
      return ["FREE", "PREMIUM"].includes(user.role);
    case "xCase":
      return user.role === 'supporter';
    default:
      return true;
  }
};

const getSectorIcons = (code) => {
  switch (code) {
    case 'ENE':
      return "fas fa-bolt";
    case 'HEA':
      return "fas fa-heartbeat";
    case 'IND':
      return "fas fa-industry";
    case 'AGR':
      return "fas fa-seedling";
    case 'FIN':
      return "fas fa-dollar-sign";
    case 'TEC':
      return "fas fa-laptop";
    case 'REA':
      return "fas fa-home";
    case 'MAT':
      return "fas fa-flask";
    case 'TEL':
      return "fas fa-phone";
    case 'CON':
      return "fas fa-shopping-cart";
    case 'UTI':
      return "fas fa-plug";
    default:
      return "";
  }
};

const getNotificationIcons = (type) => {
  switch (type) {
    case 'marketing':
      return "fas fa-bullhorn";
    case 'personal':
      return "fas fa-cog";
    case 'market':
      return "fas fa-wave-square";
    case "analysis":
      return "fas fa-file-medical"
    case "news":
      return "far fa-newspaper";
    default:
      return "";
  }
}

const getTypeIcons = (code) => {
  if (code.length > 3) {
    code = code.substring(0, 3);
  }
  switch (code) {
    case 'CYC':
      return "fas fa-sync-alt";
    case 'DEF':
      return "fas fa-shield-alt";
    default:
      return '';
  }
};

const getAvailableIcons = (code) => {
  if (code === 'true') {
    return 'fas fa-check';
  }
  return 'fas fa-times';
};

const getFeatureIcons = (code) => {
  switch (code) {
    case 'ranking':
      return "icon-trophy";
    case 'market_cycle':
      return "fas fa-globe";
    case 'competitors':
      return "fas fa-industry";
    case 'dca':
      return 'fas fa-chess-queen';
    case 'mos':
      return 'far fa-life-ring';
    case 'watchlist':
      return 'fas fa-eye';
    case 'unwatchlist':
      return 'fas fa-eye-slash';
    case 'portfolio':
      return 'fa fa-heart';
    case 'financial_ratios':
      return 'fas fa-qrcode';
    case 'analysis':
      return "fas fa-file-medical";
    case 'trading_view':
      return 'fas fa-chart-line';
    case 'beta':
      return 'fab fa-behance';
    case 'dividend':
      return 'far fa-money-bill-alt';
    case 'management':
      return 'fas fa-users-gear';
    default:
      return "";
  }
};

const getFeatureNames = (code) => {
  return i18n.t(`features.${code}`);
};

const getBusinessTypeText = (code) => {
  if (code) {
    if (code.length > 3) {
      code = code.substring(0, 3);
    }
    return i18n.t(`business_types.${code.toLowerCase()}`);
  }
};

const getSectorText = (code) => {
  const mapSector = {
    ENE: 'energy',
    HEA: 'health',
    IND: 'industry',
    AGR: 'agri',
    FIN: 'fin',
    TEC: 'tech',
    REA: 'real',
    MAT: 'material',
    TEL: 'telecom',
    CON: 'consumer',
    UTI: 'utility',
    UNK: 'unknown'
  };
  let name = mapSector[code];
  if (name) {
    return i18n.t(`sector_types.${mapSector[code]}`);
  }
};

const getTypeOptions = () => {
  var options = [
    { code: 'DEF', name: i18n.t('business_types.def') },
    { code: 'CYC', name: i18n.t('business_types.cyc') }
  ];
  return options;
}

const getMonthlyOptions = () => {
  let options = [
    { code: 12, name: `1 ${i18n.t('timeframe.year')}` },
    { code: 24, name: `2 ${i18n.t('timeframe.year')}` },
    { code: 36, name: `3 ${i18n.t('timeframe.year')}` },
    { code: 48, name: `4 ${i18n.t('timeframe.year')}` },
    { code: 60, name: `5 ${i18n.t('timeframe.year')}` },
  ];
  return options;
}

const getPeriodOptions = () => {
  let options = [
    { code: 'monthly', name: `1 ${i18n.t('timeframe.month')}` },
    { code: 'quarterly', name: `3 ${i18n.t('timeframe.month')}` },
    { code: 'half_year', name: `6 ${i18n.t('timeframe.month')}` },
    { code: 'annual', name: `1 ${i18n.t('timeframe.year')}` },
    { code: 'three_years', name: `3 ${i18n.t('timeframe.year')}` },
    { code: 'max', name: `${i18n.t('timeframe.all')}` },
  ];
  return options;
}

const getStatementOptions = () => {
  let options = [
    { code: 'inventory', name: `${i18n.t('stocks.statements.inventory')}` },
    { code: 'revenue', name: `${i18n.t('stocks.statements.revenue')}` },
    { code: 'operating_cost', name: `${i18n.t('stocks.statements.operating_cost')}` },
    { code: 'interest_cost', name: `${i18n.t('stocks.statements.interest_cost')}` },
    { code: 'equity', name: `${i18n.t('stocks.statements.equity')}` },
    { code: 'current_debt', name: `${i18n.t('stocks.statements.current_debt')}` },
    { code: 'debt', name: `${i18n.t('stocks.statements.debt')}` },
    { code: 'cash', name: `${i18n.t('stocks.statements.cash')}` },
    { code: 'dividend', name: `${i18n.t('stocks.statements.dividend')}` },
    { code: 'rnd', name: `${i18n.t('stocks.statements.rnd')}` },
    { code: 'retained_earnings', name: `${i18n.t('stocks.statements.retained_earnings')}` },
    { code: 'current_retained_earnings', name: `${i18n.t('stocks.statements.current_retained_earnings')}` },
    { code: 'operating_cf', name: `${i18n.t('stocks.statements.operating_cf')}` },
    { code: 'fcf', name: `${i18n.t('stocks.statements.fcf')}` },
    { code: 'income', name: `${i18n.t('stocks.statements.income')}` },
  ];
  return options;
}

const getDailyOptions = () => {
  let options = [
    { code: 30, name: `1 ${i18n.t('timeframe.month')}` },
    { code: 90, name: `3 ${i18n.t('timeframe.month')}` },
    { code: 180, name: `6 ${i18n.t('timeframe.month')}` },
    { code: 365, name: `1 ${i18n.t('timeframe.year')}` },
  ];
  return options;
}

function formatDate(timestamp) {
  const date = new Date(timestamp);
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  return date.toLocaleDateString('vi-VN', options).replace(/\//g, '-');
}

function formatWeekday(timestamp) {
  const date = new Date(timestamp);
  const options = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };
  return date.toLocaleDateString('vi-VN', options).replace(/\//g, '-');
}

export default {
  checkRole,
  getSectorIcons,
  getTypeIcons,
  getFeatureIcons,
  getFeatureNames,
  getSectorText,
  getAvailableIcons,
  getBusinessTypeText,
  getTypeOptions,
  getMonthlyOptions,
  getDailyOptions,
  formatDate,
  formatWeekday,
  getNotificationIcons,
  getPeriodOptions,
  getStatementOptions
};
